import React from 'react';

// Centralized brand asset paths — all self-hosted under /brand/
export const BRAND = {
  motorinks: {
    primary: '/brand/motorinks-primary.webp',   // full lockup with "Graphics Industry Specialist"
    symbol:  '/brand/motorinks-symbol.png',     // constrained (icon / mobile / footer)
    alt:     'Motor iNKS · Graphics Industry Specialist',
  },
  wrapulator: {
    primary: '/brand/wrapulator-primary.webp',  // full MI Wrapulator lockup
    icon:    '/brand/wrapulator-icon.png',      // mascot icon (constrained)
    alt:     'Motor iNKS Wrapulator',
  },
};

/**
 * <MotorInksLogo variant="primary|symbol" className size />
 * Auto-picks the constrained "symbol" variant on <md screens unless variant is forced.
 */
export function MotorInksLogo({ variant = 'auto', className = '', height = 44, alt }) {
  if (variant === 'auto') {
    return (
      <>
        <img
          src={BRAND.motorinks.symbol}
          alt={alt || BRAND.motorinks.alt}
          height={height}
          style={{ height }}
          className={`md:hidden w-auto ${className}`}
          loading="eager"
          decoding="async"
        />
        <img
          src={BRAND.motorinks.primary}
          alt={alt || BRAND.motorinks.alt}
          height={height}
          style={{ height }}
          className={`hidden md:block w-auto ${className}`}
          loading="eager"
          decoding="async"
        />
      </>
    );
  }
  const src = variant === 'symbol' ? BRAND.motorinks.symbol : BRAND.motorinks.primary;
  return (
    <img
      src={src} alt={alt || BRAND.motorinks.alt}
      height={height} style={{ height }}
      className={`w-auto ${className}`}
      loading="eager" decoding="async"
    />
  );
}

export function WrapulatorLogo({ variant = 'primary', className = '', height = 60, alt }) {
  const src = variant === 'icon' ? BRAND.wrapulator.icon : BRAND.wrapulator.primary;
  return (
    <img
      src={src} alt={alt || BRAND.wrapulator.alt}
      height={height} style={{ height }}
      className={`w-auto ${className}`}
      loading="lazy" decoding="async"
    />
  );
}
